/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, FlexContainer, Heading } from "@nordcloud/gnui";

export function DefaultErrorFallback() {
  return (
    <div css={{ maxWidth: "100%", padding: "3rem" }}>
      <FlexContainer alignItems="center" direction="column">
        <Heading level={1} mb={0} as="p">
          Ooooops
        </Heading>
        <Heading level={4} mb={3} as="p">
          Looks like something went wrong
          <br /> Our cloud ninjas are on their way to fix it.
        </Heading>
      </FlexContainer>
    </div>
  );
}

type Props = {
  resetErrorBoundary: () => void;
};

export function RecoverErrorFallback({ resetErrorBoundary }: Props) {
  return (
    <div css={{ maxWidth: "100%", padding: "3rem" }}>
      <FlexContainer justifyContent="center" direction="column">
        <Heading level={1} mb={0} as="p">
          Ooooops
        </Heading>
        <Heading level={4} mb={3} as="p">
          Looks like something went wrong
        </Heading>
        <Button onClick={resetErrorBoundary}>Reload</Button>
      </FlexContainer>
    </div>
  );
}
